import React from 'react';
import PropTypes from 'prop-types';
import { LinearProgress, Typography } from '@material-ui/core';

import { useStyles } from './usageBar.styles';

function getUsageBarColor (usedPercent) {
    if (usedPercent >= 100) return '#BD0043';
    if (usedPercent >= 90) return '#FF5900';
    if (usedPercent >= 80) return '#FFB300';
    return '#0000D9';
}

function UsageBar (props) {
    const {
        label,
        used,
        total,
        remaining,
        usedPercent,
        resetLabel,
    } = props;

    const classes = useStyles({ barColor: getUsageBarColor(usedPercent), hasResetLabel: !!resetLabel });

    return (
        <div className={classes.usageBox}>
            <div className={classes.usageRow}>
                <Typography variant={'body2'} className={classes.usageLabel}>
                    {label}
                </Typography>
                <Typography variant={'body2'} className={classes.usageValue}>
                    {`${used.toLocaleString()} of ${total.toLocaleString()} used`}
                </Typography>
            </div>
            <LinearProgress
                variant={'determinate'}
                value={usedPercent}
                classes={{
                    root: classes.progressRoot,
                    bar: classes.progressBar,
                }}
            />
            <div className={classes.usageSubRow}>
                {resetLabel && (
                    <Typography className={classes.resetLabel}>
                        {resetLabel}
                    </Typography>
                )}
                <Typography className={classes.remaining}>
                    {`${remaining.toLocaleString()} remaining`}
                </Typography>
            </div>
        </div>
    );
}

UsageBar.propTypes = {
    label: PropTypes.string,
    used: PropTypes.number,
    total: PropTypes.number,
    remaining: PropTypes.number,
    usedPercent: PropTypes.number,
    resetLabel: PropTypes.string,
};

UsageBar.defaultProps = {
    label: 'Subscriber usage',
    used: 0,
    total: 0,
    remaining: 0,
    usedPercent: 0,
    resetLabel: '',
};

export default UsageBar;
